<template>
  <v-toolbar-title>
    <slot />
  </v-toolbar-title>
</template>
